import configuration from '@atom/utilities/configuration';

import { configureStore as configureDevStore } from './store.dev';
import { configureStore as configureProdStore } from './store.production';

export const configureStore =
  configuration.environment === 'production'
    ? configureProdStore
    : configureDevStore;
